/* Autogenerated by Makefile :: patch-version */
export default 'v3.227.0'
